import React from 'react';

const _404_ = () => (
    <div>
        404 page template
    </div>
);

export default _404_;